export default __webpack_public_path__ + "media/components/Pages/Abitur/Images/How/1-c9564e804a2cb4368f698257a52cd4f7.svg";